import { useAtomValue } from "jotai";
import { type Dispatch, type SetStateAction, useEffect } from "react";

import { onlyOnePlayingPlayerAtom } from "~/lib/only-one-playing-player";

type UseAdManualPauseEffectParameters = {
  setManualPaused: Dispatch<SetStateAction<boolean>>;
};

export const useAdManualPauseEffect = ({ setManualPaused }: UseAdManualPauseEffectParameters) => {
  const { isAdManualPaused } = useAtomValue(onlyOnePlayingPlayerAtom);

  useEffect(() => {
    setManualPaused(isAdManualPaused);
  }, [isAdManualPaused, setManualPaused]);
};
